import { render, staticRenderFns } from "./PfvImage.vue?vue&type=template&id=40939bee&"
import script from "./PfvImage.vue?vue&type=script&lang=js&"
export * from "./PfvImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports